/**
 * camelCase to snake_case
 *
 * @param {string} str Заданная строка
 *
 * @return {string}
 *
 * @example camelToSnake('myArg') => 'my_arg';
 */

export const camelToSnake = (str: string) =>
	str.replace(/[\w]([A-Z])/g, function(char: string) {
		return char[0] + '_' + char[1];
	}).toLowerCase();
